import React from 'react';
import { Section, VideoPlayer } from './ui';
export const Bonuses = () => {
  const bonuses = [{
    id: 1,
    title: 'Guía Inteligente de Harinas',
    desc: 'Para que no gastes de más ni vuelvas a equivocarte.',
    value: '$19.000 ARS',
    img: 'https://cdn.magicpatterns.com/uploads/tBehLnwFt7HJESTsK39NfZ/MTq8Fvd.jpg'
  }, {
    id: 2,
    title: 'Guía de Endulzantes',
    desc: 'Endulza sin picos, sin culpa y sin arruinar la textura.',
    value: '$15.000 ARS',
    img: 'https://cdn.magicpatterns.com/uploads/cjdtLU7aA3JcCc663bmrn7/Xrgucaf.jpg'
  }, {
    id: 3,
    title: 'Pasteles para Niños',
    desc: 'Recetas que los niños aman… sin notar la diferencia.',
    value: '$25.000 ARS',
    img: 'https://cdn.magicpatterns.com/uploads/p2d9VhiQsKYfGfyRJfhiBP/NZkEkL1.jpg'
  }, {
    id: 4,
    title: 'Checklist del Horno Perfecto',
    desc: 'Evita errores comunes de temperatura, tiempo y molde.',
    value: '$10.000 ARS',
    img: 'https://cdn.magicpatterns.com/uploads/mvaEnTR9aN5eohxR7yEEeN/KVCS5xC.jpg'
  }, {
    id: 5,
    title: 'Planificador Semanal',
    desc: 'Organiza horneadas y compras sin estrés.',
    value: '$10.000 ARS',
    img: 'https://cdn.magicpatterns.com/uploads/bisofDK21ZCpcCcSAxASDZ/gJsE26u.jpg'
  }, {
    id: 6,
    title: 'Delicias en 15 Minutos',
    desc: 'Para esos antojos urgentes.',
    value: '$19.000 ARS',
    img: 'https://cdn.magicpatterns.com/uploads/hqRT2o8gmkjQdw5p66t7fU/7O4A1Cy.jpg'
  }];
  return <Section className="bg-white" data-id="element-18">
      <div className="text-center mb-12" data-id="element-19">
        <div className="inline-block bg-pink-100 text-pink-800 font-bold px-6 py-3 rounded-full text-xl md:text-2xl mb-8" data-id="element-20">
          🎁 Y además, HOY recibes 7 bonos GRATIS
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-21">
        {bonuses.map(bono => <div key={bono.id} className="bg-white rounded-2xl p-5 shadow-soft border border-gray-100 flex flex-col h-full text-center md:text-left" data-id="element-22">
            <img src={bono.img} alt={`Bono ${bono.id}`} className="w-full h-48 sm:h-56 object-contain bg-brand-cream rounded-xl mb-5" data-id="element-23" />
            <h4 className="text-lg md:text-xl font-bold mb-3 text-brand-dark leading-snug" data-id="element-24">
              🎁 BONO #{bono.id} – {bono.title}
            </h4>
            <p className="text-base text-gray-600 mb-5 flex-grow" data-id="element-25">
              {bono.desc}
            </p>
            <div className="bg-gray-50 p-3 rounded-lg text-center border border-gray-100" data-id="element-26">
              <p className="text-sm text-gray-500 font-bold mb-1" data-id="element-27">Valor:</p>
              <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-28">
                <span className="text-base font-bold text-gray-400 line-through decoration-red-500" data-id="element-29">
                  {bono.value}
                </span>
                <span className="text-lg font-extrabold text-brand-green" data-id="element-30">
                  $0 ARS
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-gradient-to-br from-yellow-50 to-amber-100 rounded-3xl p-6 md:p-10 shadow-lg border-2 border-yellow-400 mb-12 relative overflow-hidden" data-id="element-31">
        <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 font-bold px-4 py-2 rounded-bl-2xl text-sm md:text-base" data-id="element-32">
          PREMIUM
        </div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center text-center md:text-left mt-4 md:mt-0" data-id="element-33">
          <div className="w-full max-w-xs md:w-1/3 md:max-w-none mx-auto" data-id="element-34">
            <img src="https://cdn.magicpatterns.com/uploads/n4eWiUb3mVKchHYASnw3iz/tDzOXHm.jpg" alt="Postres en Vaso" className="w-full h-auto rounded-xl shadow-md" data-id="element-35" />
          </div>
          <div className="w-full md:w-2/3" data-id="element-36">
            <h4 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 text-yellow-900 leading-tight" data-id="element-37">
              ⭐ BONO PREMIUM – Postres en Vaso
            </h4>
            <p className="text-base md:text-lg text-yellow-800 mb-5" data-id="element-38">
              Para cuando quieres algo dulce, rápido y controlado sin sabotear
              tu cuerpo.
            </p>
            <div className="bg-white/70 p-4 rounded-xl inline-block" data-id="element-39">
              <p className="text-xs md:text-sm text-yellow-700 font-bold uppercase mb-1" data-id="element-40">
                Valor:
              </p>
              <div className="flex items-center justify-center md:justify-start gap-3 flex-wrap" data-id="element-41">
                <span className="text-lg md:text-xl font-bold text-gray-500 line-through decoration-red-500" data-id="element-42">
                  $29.000 ARS
                </span>
                <span className="text-xl md:text-2xl font-extrabold text-brand-green" data-id="element-43">
                  $0 ARS
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VideoPlayer src="https://i.imgur.com/AnkMD5c.mp4" data-id="element-44" />
    </Section>;
};